import errorTrackingService from '../services/errorTrackingService'
import {
  clearGuestScheduleFlow,
  clearScheduleGuestBookingOrigin
} from './scheduleGuestFlow'

export const CLINICS_SEARCH_ENDPOINT = '/v1/clinics/search'

export class ClinicsSearchHttpError extends Error {
  constructor (status, message, data = null) {
    super(message || 'Clinics search request failed')
    this.name = 'ClinicsSearchHttpError'
    this.status = status
    this.isAPIError = true
    this.response = { status, data }
  }
}

export const isClinicsSearchHttpError = (error) =>
  error?.name === 'ClinicsSearchHttpError' ||
  typeof error?.status === 'number'

export const persistScheduleLoginRedirect = ({
  pathname = '/calendario',
  search = '',
  serviceId
} = {}) => {
  clearGuestScheduleFlow()
  clearScheduleGuestBookingOrigin()

  const normalizedSearch = search?.startsWith?.('?') ? search.slice(1) : search || ''
  const params = new URLSearchParams(normalizedSearch)

  if (serviceId != null && serviceId !== '') {
    params.set('serviceId', String(serviceId))
  }

  const query = params.toString()
  localStorage.setItem(
    'routeToRedirect',
    JSON.stringify({
      pathname,
      search: query ? `?${query}` : ''
    })
  )
}

const logClinicsSearchError = (error, context = {}) => {
  errorTrackingService.trackAPIError(
    error,
    CLINICS_SEARCH_ENDPOINT,
    'POST',
    'Schedule Clinics Search Error',
    {
      flow: 'guest_schedule',
      ...context
    }
  )
}

/**
 * Guest clinics search error handling:
 * - 403 → save schedule route (with serviceId) and redirect to login
 * - 5xx → generic schedule error page
 * All cases are logged.
 */
export const handleClinicsSearchFlowError = (
  error,
  navigate,
  { serviceId, pathname = '/calendario', search = '' } = {}
) => {
  logClinicsSearchError(error, { serviceId, pathname, search })

  const status = error?.status ?? error?.response?.status

  if (status === 403) {
    persistScheduleLoginRedirect({ pathname, search, serviceId })
    navigate('/login', { replace: true })
    return { handled: true, action: 'login_redirect' }
  }

  if (status >= 500 && status < 600) {
    navigate('/errorAgenda', { replace: true })
    return { handled: true, action: 'server_error' }
  }

  return { handled: false }
}

export const tryHandleClinicsSearchFlowError = (
  error,
  navigate,
  context = {}
) => {
  if (!isClinicsSearchHttpError(error)) {
    return { handled: false }
  }

  return handleClinicsSearchFlowError(error, navigate, context)
}
